import React from 'react';
import { getTabList } from './tabs';
import { Tabs } from '../../styles';
import useAdvertisementTabs from './hooks/useAdvertisementTabs';
import { FORM_TAB_GROUP_ARIA_LABEL } from '../constants';
export var ADVERTISEMENT_FORM_TABS_ID = 'advertisement-form-tabs';
export var ADVERTISEMENT_FORM_TAB_TEST_ID = 'advertisement-form-tab-test';
var AdvertisementForm = function AdvertisementForm(_ref) {
  var citation = _ref.citation;
  var _useAdvertisementTabs = useAdvertisementTabs({
      intialPubtypeState: citation === null || citation === void 0 ? void 0 : citation.data.pubtype
    }),
    activeTabIndex = _useAdvertisementTabs.activeTabIndex,
    handleTabChange = _useAdvertisementTabs.handleTabChange;
  return /*#__PURE__*/React.createElement(Tabs, {
    tabs: getTabList(activeTabIndex),
    activeTabIndex: activeTabIndex,
    id: ADVERTISEMENT_FORM_TABS_ID,
    onChangeIndex: handleTabChange,
    "aria-label": FORM_TAB_GROUP_ARIA_LABEL,
    "data-test": ADVERTISEMENT_FORM_TAB_TEST_ID
  });
};
export default AdvertisementForm;